export default class {
    send = function (data, success, fail, route = '/ajax') {
        success = success || function (response) {
            console.log(response)
        };
        fail = fail || function (error) {
            console.log(error)
        };
        return axios.post(route, data)
            .then(success)
            .catch(fail);
    }
}
